<template>
  <section v-if="link" class="container-fluid bg-light-2 pb-space-md pb-lg-0 px-space-md">
    <div class="row">
      <div
        class="col-12 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center"
      >
        <div
          class="bg-secondary rounded-circle icon-wrapper mb-space-xs mb-lg-0 d-flex justify-content-center align-items-center"
        >
          <font-awesome-icon :icon="['fa-solid', 'fa-bell']"></font-awesome-icon>
        </div>

        <p class="mb-lg-0">This program is also available in-person.&nbsp;</p>
        <a class="non-rds-link" :href="link" target="_blank">Explore campus options </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
type Prop = {
  link: string | null;
};
defineProps<Prop>();
</script>

<style scoped>
.icon-wrapper {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}
</style>
